httpVueLoader.register(Vue, "components/contact.vue");

const store = new Vuex.Store({
  state: {
    isIe: false,
    result: null,
  },
  mutations: {
    updateIe(state, payload) {
      state.isIe = payload;
    },
    setData(state, payload) {
      state.result = payload;
    },
  },
  actions: {
    getData(context) {
      axios.get("db.json").then((res) => {
        context.commit("setData", res.data);
      });
    },
  },
});

new Vue({
  el: "main",
  components: {
    ie: httpVueLoader("components/ie.vue"),
    web: httpVueLoader("components/WB00339901_lee/index.vue"),
  },
  computed: {
    isIe(){
      return store.state.isIe
    },
    result() {
      return store.state.result;
    },
    componentId() {
      return store.state.isIe ? "web" : "ie";
    },
  },
  methods: {
    IEVersion() {
      var userAgent = navigator.userAgent; //取得瀏覽器的userAgent字串  
      var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判斷是否IE<11瀏覽器  
      // var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判斷是否IE的Edge瀏覽器  
      var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
      if(isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if(fIEVersion == 7) {
          return 7;
        } else if(fIEVersion == 8) {
          return 8;
        } else if(fIEVersion == 9) {
          return 9;
        } else if(fIEVersion == 10) {
          return 10;
        } else {
          return 6;//IE版本<=7
        }   
      } else if(isIE11) {
        return 11; //IE11  
      }else{
        return -1;//不是ie瀏覽器
      }
      // else if(isEdge) {
        // return 'edge';//edge
      // }
    }
  },
  created() {
    this.IEVersion();
    let ie = this.IEVersion() !== -1 ? false : true;
    store.commit("updateIe", ie);
    store.dispatch("getData");
  },
  mounted() {
    new WOW().init();
  },
});
